/**
 * Уроки курса идут строго по порядку — от первого до последнего.
 *
 * Раньше записать можно было любой урок плана: третий раньше первого, второй — после четвёртого.
 * Инструктор ведёт программу по порядку, и урок 3 без урока 2 не бывает. Правило одно на запись
 * и на перенос: урок встаёт после предыдущего и до следующего.
 *
 * Отменённые уроки в порядке не участвуют — их место пусто.
 */
import { DomainError, domainAttempt } from "./errors.js";
import { parseIsoMs } from "./scheduling-time.js";
function hasTime(sibling) {
    return sibling.startTime !== null && sibling.startTime.trim() !== "";
}
export function assessLessonOrder(input) {
    return domainAttempt(() => {
        const others = input.siblings.filter((sibling) => sibling.lessonId !== input.lessonId && sibling.status !== "canceled");
        const startMs = parseIsoMs(input.startsAt);
        const earlier = others.filter((sibling) => sibling.lessonOrder < input.lessonOrder);
        const unplaced = earlier.find((sibling) => !hasTime(sibling));
        if (unplaced) {
            throw new DomainError("out_of_order", `Сначала запишите урок ${unplaced.lessonOrder}: уроки курса идут по порядку`, { lessonId: input.lessonId, blockingLessonId: unplaced.lessonId });
        }
        for (const previous of earlier) {
            if (!hasTime(previous))
                continue;
            const previousEnd = parseIsoMs(previous.startTime) + previous.durationMinutes * 60_000;
            if (startMs < previousEnd) {
                throw new DomainError("out_of_order", `Урок ${input.lessonOrder} не может начаться раньше, чем закончится урок ${previous.lessonOrder}`, { lessonId: input.lessonId, blockingLessonId: previous.lessonId });
            }
        }
        const endMs = startMs + input.durationMinutes * 60_000;
        for (const next of others) {
            if (next.lessonOrder <= input.lessonOrder || !hasTime(next))
                continue;
            if (endMs > parseIsoMs(next.startTime)) {
                throw new DomainError("out_of_order", `Урок ${input.lessonOrder} должен закончиться до начала урока ${next.lessonOrder}`, { lessonId: input.lessonId, blockingLessonId: next.lessonId });
            }
        }
    });
}
/**
 * Следующий урок, который можно записать: первый по порядку без времени. У зачисления он один —
 * остальные ждут, пока встанут предыдущие.
 */
export function nextLessonToSchedule(siblings) {
    const open = siblings
        .filter((sibling) => sibling.status !== "canceled" && sibling.status !== "completed")
        .filter((sibling) => !hasTime(sibling))
        .sort((a, b) => a.lessonOrder - b.lessonOrder);
    return open[0] ?? null;
}
